export class AppConfig {
   public static API_ENDPOINT = 'admin';
   public static API_BASE = 'http://localhost:3000';
}
